import React from 'react';
import { Container, Body5 } from '@ui';
import { NodeParameterRemoveButton } from '@flow/buttons/NodeParameterRemoveButton';
import { AgentFlowParameterWrapper, AgentFlowParameterLabelWrapper } from '@flow/styles';

export const BoolParameter = ({ data, value, onRemove, onChange }) => {
  const { keyName, label } = data;

  const handleChange = (e) => {
    onChange(keyName, !value);
  };
  const handleRemoveClick = () => onRemove(keyName);

  return (
    <AgentFlowParameterWrapper>
      <label htmlFor={'checkbox-' + keyName} className="not-selectable" style={{ cursor: 'pointer', margin: 0 }}>
        <AgentFlowParameterLabelWrapper>
          <Container bottom={3} style={{ width: label.length > 26 ? '200px' : '120px' }}>
            <Body5>{label}:</Body5>
          </Container>
        </AgentFlowParameterLabelWrapper>
      </label>
      <Container row fullWidth verticallyCenter spaceBetween style={{ height: '31px' }}>
        <input
          type="checkbox"
          id={'checkbox-' + keyName}
          checked={value}
          onClick={handleChange}
          style={{ cursor: 'pointer', marginTop: 0, marginLeft: '0px', width: '18px' }}
        />
        <NodeParameterRemoveButton onClick={handleRemoveClick} />
      </Container>
    </AgentFlowParameterWrapper>
  );
};
